export var MuiCardHeader = {
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                padding: "".concat(theme.spacing(3), " ").concat(theme.spacing(3), " ").concat(theme.spacing(2)),
            });
        },
    },
};
